import React, { useState } from "react";
import { Button, Col, Container, ListGroup, Row } from "react-bootstrap";
import propertyData from "../components/property.json";
import {
  FaBaby,
  FaBabyCarriage,
  FaChair,
  FaFan,
  FaLaptop,
  FaParking,
  FaTv,
  FaUtensils,
  FaWater,
  FaWifi,
} from "react-icons/fa";
import { MdLocationPin } from "react-icons/md";

export default function PropertyInformation() {
  const toggleReadMore = () => {
    var readMoreContent = document.getElementById("readMoreContent");
    var readMoreButton = document.getElementById("readMoreButton");

    if (
      readMoreContent.style.display === "none" ||
      readMoreContent.style.display === ""
    ) {
      readMoreContent.style.display = "block";
      readMoreButton.innerHTML = "Read Less...";
    } else {
      readMoreContent.style.display = "none";
      readMoreButton.innerHTML = "Read More...";
    }
  };

  const [showLocationDetails, setShowLocationDetails] = useState(false);

  const toggleLocationDetails = () => {
    setShowLocationDetails(!showLocationDetails);
  };

  return (
    <>
      <Row>
      <hr />
        <h5 className="mb-2">Information about the property</h5>
        <Row>
          <Col>
            <Container>
              <p>
                This is a first floor apartment situated in the heart of a lovely village 
                called Rhos on Sea, with its many shops, cafés, restaurants and the harbour and beach. 
              </p>
              <p>
                It is an attractive 3 bedroom (one bathroom) accommodation which can sleep 7.
                Well behaved dogs are permitted, and there are bowls and protective sheets to cover furniture in the dog cupboard
              </p>
              <p>
                It is comfortable, self catering and convenient for anyone who wishes to attend 
                nearby shows, concerts or rugby games, close to Llandudno, Betws y Coed, Llanberis and 
                Snowdonia for site seeing, outdoor pursuits, zip wire, bounce below, surfing, walking, running, 
                mountain climbing, cycling, swimming and much more.
              </p>
              <p>
                Parking is restricted immediately outside, but available further along the road.
              </p>
              <p>
                Anyone wishing to attend Art Classes can arrange directly with us. <a href="https://ginnyhelsen.co.uk/lessons-and-workshops">Click here for more information</a>
              </p>
            </Container>
          </Col>
        </Row>
        <hr />

        <Row className="my-4">
          <h5>Amenities:</h5>
          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <FaWater className="icon" /> Public or shared beach access
              </ListGroup.Item>
              <ListGroup.Item>
                <FaUtensils className="icon" /> Kitchen
              </ListGroup.Item>
              <ListGroup.Item>
                <FaWifi className="icon" /> Wifi – 36 Mbps
              </ListGroup.Item>
              <ListGroup.Item>
                <FaLaptop className="icon" /> Dedicated workspace
              </ListGroup.Item>
              <ListGroup.Item>
                <FaParking className="icon" /> Free parking on premises
              </ListGroup.Item>
            </ListGroup>
          </Col>
          <Col md={6}>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <FaTv className="icon" /> 40" HDTV
              </ListGroup.Item>
              <ListGroup.Item>
                <FaBabyCarriage className="icon" /> Cot
              </ListGroup.Item>
              <ListGroup.Item>
                <FaBaby className="icon" /> Travel cot
              </ListGroup.Item>
              <ListGroup.Item>
                <FaChair className="icon" /> High chair
              </ListGroup.Item>
              <ListGroup.Item>
                <FaFan className="icon" /> Hair dryer
              </ListGroup.Item>
            </ListGroup>
          </Col>
        </Row>
        <p className="Note">
          Please note: Up to 2 well-behaved dogs welcome at an additional charge
          of £25 per pet, per stay.
        </p>
        <p className="Note">
          Please Note: Pets must NOT be allowed on the furniture or the beds.
        </p>
        <p className="Note">
          Please note: Cot and Highchair available on request.
        </p>
        <hr />
        <h5>
          Location
        </h5>
        <p className="mt-3"><MdLocationPin size={28}></MdLocationPin>{propertyData.location}</p>
        <div className="iFrame" id="map">
          <iframe
            className="my-3"
            title="maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2384.0242605299195!2d-3.7429705241376876!3d53.30701177766696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48651f8c655b5f75%3A0x6d7f7f3e4f62f68c!2sEverard%20Rd%2C%20Rhos%20on%20Sea%2C%20Colwyn%20Bay!5e0!3m2!1sen!2suk!4v1696437405430!5m2!1sen!2suk"
            width="100%"
            height="450"
            allowFullScreen={false}
            loading="lazy"
          ></iframe>
          <Row className="my-4">
        <Col>
          <h5 className="font-weight-bold">About the Location:</h5>
          <p>Rhos-on-Sea,
            Colwyn Bay 2 miles; Llandudno 4 miles; Betws-y-Coed 18 miles.
          </p>
          <Container>
            <p>
              The elegant seaside resort of Rhos-on-Sea is a coastal town in North Wales. With its picturesque harbour and relaxed atmosphere, it is the ideal location for a peaceful holiday. Situated in the shadow of the towering Bryn Euryn, with Penrhyn Bay to the west and Colwyn Bay to the east, there is plenty to keep everybody occupied. Energetic visitors can climb the 365 feet of Bryn Euryn and discover the fascinating hill fort 'Dinerth' at the top, while those who prefer a more relaxed walk can stroll along the promenade, taking in the beautiful surroundings overlooking the Irish Sea. Spend a day on the beach at Colwyn Bay, enjoying the abundance of water sports available at Port Eirias, where boats, kayaks, and windsurfers can be hired. Take a boat trip out to spot seals, porpoises, and dolphins, or enjoy a round of golf at Rhos-on-Sea's golf club. With lots to do close by, and beautiful Conwy Castle and the Victorian seaside town of Llandudno within a short drive, there is never a shortage of things to do in Rhos-on-Sea.
            </p>
          </Container>
          {showLocationDetails && (
            <div id="readMoreLocation">
              <Container>
                <p>
                  Additional details about the location can go here.
                </p>
              </Container>
            </div>
          )}
          <Button
            id="locationDetailsButton"
            variant=""
            className="mb-4 fw-bold"
            onClick={() => toggleLocationDetails()}
          >
            {showLocationDetails ? "Read Less..." : "Read More..."}
          </Button>
        </Col>
      </Row>
        </div>
      </Row>
    </>
  );
}
